<div class="responsive-card gap-4">
  <div i18n class="responsive-card-title">Age for Minimum Calculation</div>

  <ng-container *ngIf="isUnchanged; else comparisonView">
    <div class="min-age-grid">
      <ng-container *ngFor="let row of comparisonRows; trackBy: trackByIndex">
        <ng-container *ngTemplateOutlet="ageCard; context: { row: row.new }" />
      </ng-container>
    </div>
  </ng-container>

  <ng-template #comparisonView>
    <div class="effective-date-banner d-flex flex-column gap-1">
      <div class="title-sm" i18n>Changes Take Effect {{ effectiveDate | date : 'MMMM d, yyyy' }}</div>
      <div class="value" i18n>
        Changes to the age for minimum calculation come into effect at the start of the next calendar year. Annual
        minimum values for that year, and future years, will be impacted.
      </div>
    </div>

    <div class="comparison-grid">
      <div class="comparison-col d-flex flex-column gap-3">
        <span class="label-sm" i18n>Current</span>
        <ng-container *ngFor="let row of comparisonRows; trackBy: trackByIndex">
          <ng-container *ngTemplateOutlet="ageCard; context: { row: row.current, highlightCurrent: row.changed }" />
        </ng-container>
      </div>
      <div class="comparison-col d-flex flex-column gap-3">
        <span class="label-sm" i18n>New</span>
        <ng-container *ngFor="let row of comparisonRows; trackBy: trackByIndex">
          <ng-container *ngTemplateOutlet="ageCard; context: { row: row.new, highlightNew: row.changed }" />
        </ng-container>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #ageCard let-row="row" let-highlightCurrent="highlightCurrent" let-highlightNew="highlightNew">
  <div class="inner-card d-flex flex-column gap-3" [class.current]="highlightCurrent" [class.new]="highlightNew">
    <div class="d-flex align-items-center gap-2">
      <div *ngIf="row.jurisdictionName; else nonLockedInName" class="label-sm">{{ row.jurisdictionName }}</div>
      <ng-template #nonLockedInName><div class="label-sm" i18n>Non-Locked-In</div></ng-template>
    </div>
    <hr class="m-0" />
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column gap-2">
        <div class="label-sm">{{ row.personName }}</div>
        <div class="value">
          <span *ngIf="row.isSpouse; else memberRole" i18n>Spouse</span>
          <ng-template #memberRole><span i18n>Member</span></ng-template>
        </div>
      </div>
      <div class="d-flex flex-column gap-2">
        <div class="label-sm text-end" i18n>Age: {{ row.age }}</div>
        <div class="date-of-birth">{{ row.dateOfBirth | date : 'MMM d, yyyy' }}</div>
      </div>
    </div>
  </div>
</ng-template>
